import { render, staticRenderFns } from "./request_message.vue?vue&type=template&id=52c017ed&scoped=true&"
import script from "./request_message.vue?vue&type=script&lang=js&"
export * from "./request_message.vue?vue&type=script&lang=js&"
import style0 from "./request_message.vue?vue&type=style&index=0&id=52c017ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c017ed",
  null
  
)

export default component.exports